// multiverse-collections.js

document.addEventListener("DOMContentLoaded", function () {
  const tabSections = document.querySelectorAll(".factotum-tabs");

  tabSections.forEach(section => {
    const tabs = section.querySelectorAll(".factotum-tabs__tab");
    const panels = section.querySelectorAll(".factotum-tabs__panel");

    tabs.forEach(tab => {
      tab.addEventListener("click", () => {
        const targetId = tab.dataset.tabTarget;

        // Remove active classes
        tabs.forEach(t => t.classList.remove("is-active"));
        panels.forEach(p => p.classList.remove("is-active"));

        // Add to current
        tab.classList.add("is-active");
        section.querySelector(`#${targetId}`).classList.add("is-active");
      });
    });
  });
});
